var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKraft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1592 301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#outer-glow-10);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        filter: url(#outer-glow-1);\n      }\n\n      .cls-3 {\n        filter: url(#outer-glow-9);\n      }\n\n      .cls-4 {\n        filter: url(#outer-glow-6);\n      }\n\n      .cls-5 {\n        filter: url(#outer-glow-8);\n      }\n\n      .cls-6 {\n        filter: url(#outer-glow-7);\n      }\n\n      .cls-7 {\n        filter: url(#outer-glow-4);\n      }\n\n      .cls-8 {\n        filter: url(#outer-glow-5);\n      }\n\n      .cls-9 {\n        filter: url(#outer-glow-2);\n      }\n\n      .cls-10 {\n        filter: url(#outer-glow-3);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-10",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#635631",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-10",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M709.84,141.84c-.03-14.54-.03-29.09,0-43.65-12.51-.09-24.99-.06-37.5-.03-.03-15.87-.06-31.75.06-47.58-16.54.08-33.1.05-49.63.03v47.52h-20.57c-.03,14.55,0,29.12,0,43.71h20.54v.03h.03c.05,13.29-.02,26.59-.02,39.88h0c0,1.11,0,2.22,0,3.32,0,.83,0,1.67,0,2.5h0c0,7.75.02,15.49.13,23.25.42,20.94,8.04,43.39,25.68,55.69,15.52,11.09,34.87,13.17,53.43,12.93-15.27-15.91-24.43-39.15-28.11-57.82l-.11-.54-.07-.55c-.5-4.1-1.12-10.67-1.05-17.62-.12-1.49-.2-2.96-.27-4.42-.05-3.78-.05-7.55-.07-11.32-.07-15.12.09-30.21.04-45.3,12.48.03,24.99.03,37.5-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M592.93,64.23c-.09-14.58-.09-29.16,0-43.74-24.49-4.11-52.68-2.48-72.3,14.44-17.55,15.77-21,40.85-20.37,63.24h-21.44c.02,14.57.02,29.14,0,43.72h18.11c1.15,0,2.3-.02,3.45-.02v.02h.1v23.89h-.08c.04,35.76.05,71.55-.02,107.31h23.04c9.11,0,18.22,0,27.33-.03-.02-36.3-.05-72.59,0-108.88v-22.35h33.6c-.03-14.58-.03-29.15,0-43.71h-33.85c.45-9.83-.69-21.6,7.41-28.89,9.75-8.18,23.34-5.52,35.01-5.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M408.24,235.23c-12.75,3.93-28.31,8.29-40.02-.63-10.68-7.53-9.3-25.68,2.28-31.62,11.82-6.24,25.62-4.05,38.17-1.56,1.13,11.26,1.04,22.6-.42,33.81M410.32,273.08h22.38c4.23,0,8.47,0,12.71,0h14.14c-.3-37.47.3-74.93-.3-112.41-.39-21.99-8.73-46.38-29.7-56.7-29.98-14.9-65.1-11.54-97.09-6.42-.11,15.9-.03,31.83-.05,47.77,20.57-4.48,43.02-9.13,63.39-1.5,9.48,3.26,13.02,13.25,14.49,22.28-14.25-1.79-28.71-5.19-43.08-2.28-17.04,2.1-33.93,10.44-43.56,25.06-15.54,23.25-11.1,58.41,11.91,75.21,21.6,16.47,52.99,14.69,74.94-.21-.03,2.29-.11,6.87-.18,9.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.82,35.85c20.07.12,40.14.03,60.21.03-29.4,39.54-58.14,79.59-87.72,118.98,26.34,39.37,52.26,78.96,78.81,118.17-20.82.15-41.64-.06-62.43.12-23.18-35.19-46.43-70.35-69.51-105.61-.06,35.19-.06,70.38.03,105.58-17.94-.09-35.88-.03-53.82-.03.06-79.05.06-158.1,0-237.15,17.94-.09,35.86,0,53.79-.09-.03,37.32-.09,74.63.03,111.96,26.76-37.4,53.79-74.61,80.61-111.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M216.6,98.7c16.89-.08,33.81,0,50.73-.08-.06,11.15-.08,22.31-.27,33.45,8.19-18.48,25.92-30.52,45.6-33.69.03,16.56.24,33.14-.21,49.7-21.57,2.58-43.74,18.67-44.52,41.95-.6,27.67-.12,55.38-.15,83.07-17.07,0-34.14,0-51.18-.03.03-58.14.03-116.25,0-174.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1101.64,124.44c8.48,2.83-12.74,45.28-12.74,45.28-8.49,2.84-16.99,5.68-22.64,5.68,2.83-5.68,18.39-59.44,35.38-50.95M1117.2,237.64c-7.07,2.84-8.49,4.25-16.97,7.07-8.49,2.84-18.4,2.84-26.89,0-26.88-11.31-9.9-52.36-9.9-52.36,110.37-26.88,94.81-86.31,65.09-89.14-18.39,0-84.9,2.83-116.03,79.24-4.24,11.32-33.96,91.98,32.55,97.63,14.14,0,29.71-1.41,43.87-8.48,12.74-7.07,22.64-15.57,31.13-26.89,7.08-12.73-2.83-7.07-2.83-7.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1374.74,253.21c-1.41-1.41-4.24-1.41-5.66-2.83-8.49-5.67-1.42-21.22,0-29.72l25.47-90.55c1.42-5.67,11.32-35.38-28.31-29.73-33.96,5.67-58.02,26.89-58.02,26.89,2.84-8.48,5.67-21.22,0-24.05-7.07-2.84-48.11,9.9-58.02,18.39-2.82,0-7.07,4.25-2.82,8.5,4.23,5.65,5.66,9.89,2.82,19.8-5.65,16.98-22.63,76.41-26.88,87.73-4.24,11.32-9.9,32.55,0,39.62,7.08,5.66,36.79-7.07,41.04-9.91,4.24-1.41,8.48-4.23,9.89-5.65,5.67-5.67-2.82-8.49,5.67-38.21,0-1.42,9.9-31.13,16.97-56.6,5.67-21.23,25.47-31.13,32.55-32.55,11.32-1.41,8.5,8.5,7.08,15.57-9.9,31.13-21.22,77.83-25.47,89.15-4.25,11.32-11.32,33.96,0,38.2,9.9,7.08,55.18-12.73,59.44-15.56,8.48-5.67,8.48-8.49,4.24-8.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1202.1,253.21c-2.82-1.41-4.24-1.41-5.66-2.83-8.48-5.67-2.83-21.22,0-29.72l26.89-90.55c1.41-9.91,7.07-22.64,0-26.89-8.5-2.84-49.53,9.9-59.44,18.39-1.42,0-5.67,4.25-1.42,8.5,4.25,5.65,4.25,9.89,1.42,19.8-4.25,16.98-24.06,77.83-28.31,89.15-4.23,11.32-9.9,33.96,2.84,38.2,9.9,7.08,52.36-11.32,58.02-15.56,9.9-4.25,9.9-8.49,5.66-8.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1572.85,181.04c-4.23-15.56-29.71-19.81-39.61-11.32-5.67,5.65-8.5,16.97-7.09,19.81,24.06-7.07,28.3,14.15,24.06,22.63-8.49,12.74-11.32,16.99-22.64,16.99h-75c-1.41-1.42-2.83-2.84,0-5.67,4.24-5.65,77.83-106.12,80.67-110.37,1.41-2.83,5.65-9.9-4.26-9.9h-82.08c-8.48,0-12.73,2.82-19.8,9.9-5.66,7.08-12.73,28.3-16.98,42.45,0,0,0,5.66,8.5-1.41,1.41-1.43,4.23-7.08,8.48-7.08h49.53c15.56,0-66.52,77.83-91.98,118.86-4.25,7.08,2.82,7.08,7.07,7.08h107.55c26.88,0,22.64,4.24,36.79-15.57,0,0,43.86-56.6,36.79-76.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M981.36,229.16l29.71-114.62c19.8-69.34,31.13-72.18,38.2-79.25h-46.7c-16.97,0-29.72,24.05-32.54,39.62l-19.82,72.17h-42.45s25.46-91.98,28.3-101.88c1.41-4.25,1.41-9.91-7.07-9.91-1.43,0-90.57-2.83-118.88,7.07-12.74,4.25-31.13,15.57-36.79,32.55-4.25,9.91-9.91,28.3,2.83,62.27,1.42,4.23,4.24,7.07,5.66,8.48,4.24,2.84,41.03-2.82,39.62-2.82,2.83,0,4.25-1.43,1.41-7.08-2.83-7.08-11.31-19.81-12.73-32.54-5.66-49.53,29.72-56.61,35.37-58.02,8.49-1.42,15.57-1.42,24.06,0,2.83,0,9.91,1.41,11.32,4.25,2.84,5.65-1.42,15.56-4.24,26.88-2.83,8.5-26.88,96.23-33.96,120.28-4.24,18.4-22.64,58.02-41.04,63.68-4.25,1.42-9.91,1.42-15.57,0-5.66-1.41-11.32-4.25-15.56-7.07-11.32-11.32-18.4-33.96-19.81-50.94-1.42-21.22,2.83-36.79-1.42-36.79-7.38,0-32.04,9.74-42.04,16.92-.02.02-.03.02-.05.03-4.06,2.9-4.32,3.46-4.32,3.46-.2.2-.36.4-.47.59-2.61,4.45-2.43,20.27-1.23,29.93,4.25,21.22,15.57,45.28,32.55,56.61,45.28,31.13,124.53-25.47,133.01-31.13,12.74-11.32,21.23-26.88,24.06-38.2,4.25-14.15,11.32-38.2,11.32-38.2h42.45s-16.98,63.68-21.22,79.23c-4.24,12.74-7.08,33.96,4.24,32.55,42.46,0,59.44-15.56,60.85-16.98,1.41-1.41,1.41-4.25,0-5.66-2.82-1.41-12.73-11.32-7.07-25.46"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKraft);
export default __webpack_public_path__ + "static/media/logoKraft.46ee0417200af6b2c50645b55d7cac5b.svg";
export { ForwardRef as ReactComponent };